import { createBrowserHistory } from 'history';

const pathArray = window.location.pathname.split('/');
// @ts-ignore
export default createBrowserHistory({ basename: `/${pathArray[1]}` });
